//store.js
import Vue from 'vue';
import Nim from "../util/initNimSDK";
import emojiList from '../util/emoji'
import {baseChatUrl, baseUrl_8, faceUrl, historyMsgNum} from "../config/env";
import {expiredTime} from "../config/env";
import {creatConversionDiv, setHzLocalVal, wait} from "../util/util";
import MsgTitleWarn from '../util/msgTitleWarn'
import {Storage} from '../util/store'
import { aesEncrypt } from "../plugin/js-crypto.js"
const sendPeriod = 10;

let MsgTitleWarnFn = new MsgTitleWarn();


export const store = Vue.observable({
    showChatModel: false,
    custemInfo: {},
    imAccid: '',
    imToken: '',
    visitorId: '',
    visitorCode: '',
    companyId: '',
    serverReadLastTime: 44,
    unReadCount: 55,
    msgList: [],
    offlineConfig: null,
    offlineFormId: '',
    onlineConfig: null,
    onlineFormId: '',
    onLineForm: [],
    offLineForm: [],
    toBottom: false,
    Nim: null,
    isInput: false,
    hasHistoryMsg: true,  //是否有历史信息
    noSeeList: [],
    socket: null,
    NimStatus: false,
    loadHistory: false,
    currIsBlack: false,
    multyLang: null,
    currentTranslateCode: '',
    isLeaveMessage: '',
    failMsgClientId: [],
    showProgerss: false,
    percentage: 0,
    networkWarning: '',
    noSendMsg: [],
    hasSubOnlineForm:false,
    hasPushForm:false,
    timer:null,
    hasPushPresetText:false,
    showNoMsgModel:true,
    historyMsgList:[],
    windowOnfocus:false,
    timer2:null,
    differenceTime:0,
    serverTime:0,
    autoReplyContent1:'',
    autoReplyContent2:'',
    autoReplyTime:3,
    timer3:null,
    serviceMsgNum:0,
    conversionConfigId:null,
});



export const mutations = {
    setConversionConfigId(val){
        store.conversionConfigId = val;
    },
    setDifferenceTime(time){
        console.info("时间间隔",time)
        store.differenceTime = time;
    },
    setServerTime(time){
        store.serverTime = time;
    },

    setShowChatModel(val) {
        store.showChatModel = val;
        if (val) {
            mutations.sendMsgReceipt();
            store.noSeeList = []
        }
    },
    setShowNoMsgModel(val){
        store.showNoMsgModel = val;
        store.noSeeList = []
    },

    setStyleConfig(data) {
        store.offlineConfig = Object.assign({}, JSON.parse(data.offlineConfig));
        store.offlineFormId = data.offlineFormId;
        store.onlineConfig = Object.assign({}, JSON.parse(data.onlineConfig))
        store.onlineFormId = data.onlineFormId;
        store.preFormTag = data.preFormTag;
        store.autoReplyContent1 = data.autoReplyContent1;
        store.autoReplyContent2 = data.autoReplyContent2;
    },

    // //发送预设文本时间
    // sendPresetText(flag){
    //     let currentTime = new Date().getTime();
    //     let presetTextTime = Storage.getItem('presetTextTime');
    //     let chatTime = Number(store.onlineConfig.chatTime)||30;
    //     let hasSendpresetText = Storage.getItem('hasSendpresetText')
    //     if(store.hasPushPresetText){return}
    //     if(flag==1){
    //         if(!presetTextTime){
    //             Storage.setItem('presetTextTime',currentTime,10);
    //             presetTextTime = currentTime
    //         }
    //         clearInterval(store.timer);
    //
    //         store.timer = setInterval(()=>{
    //             if(new Date().getTime() - presetTextTime>chatTime*1000){
    //                 clearInterval(store.timer)
    //                 if(store.isLeaveMessage){return}
    //                 Storage.setItem('hasSendpresetText',true,10);       //10分钟发一次
    //                 store.hasPushPresetText  =true
    //                 store.msgList.push({
    //                     time:Number(presetTextTime),
    //                     text:store.onlineConfig.chatTxt,
    //                     flow: "in",
    //                     msg_status:'success',
    //                     type: "text"
    //                 });
    //
    //                 store.noSeeList.push({
    //                     time:new Date(presetTextTime).getTime(),
    //                     text:store.onlineConfig.chatTxt,
    //                     flow: "in",
    //                     msg_status:'success',
    //                     type: "text"
    //                 })
    //             }
    //         },1000)
    //     }else {
    //         if(!presetTextTime){
    //             Storage.setItem('presetTextTime',currentTime,3);
    //             presetTextTime = currentTime;
    //             store.msgList.push({
    //                 time:Number(presetTextTime),
    //                 text:store.onlineConfig.chatTxt,
    //                 flow: "in",
    //                 msg_status:'success',
    //                 type: "text"
    //             });
    //
    //             store.noSeeList.push({
    //                 time:new Date(presetTextTime).getTime(),
    //                 text:store.onlineConfig.chatTxt,
    //                 flow: "in",
    //                 msg_status:'success',
    //                 type: "text"
    //             })
    //         }
    //         // if(hasSendpresetText){
    //         //     store.hasPushPresetText  =true
    //         //     store.msgList.unshift({
    //         //         time:Number(presetTextTime),
    //         //         text:store.onlineConfig.chatTxt,
    //         //         flow: "in",
    //         //         msg_status:'success',
    //         //         type: "text"
    //         //     });
    //         // }
    //     }
    // },


    /*
     *10分钟循环一次，只要发过了就不发了，但是历史记录可查
     *只要访客说过话或者客服说过话就不发，等着下一个周期再发
     *根据倒计时来发
     *写个浏览器的心跳来判断是不是关闭了页面
     * */
    sendPresetTextFn(){
        if(store.preFormTag) return;
        if(store.isLeaveMessage) return;
        if(store.onlineConfig.chatTxt=='') return;

        if(!store.onlineConfig.hasOwnProperty('chatTxt')) return
        let currentTime = new Date().getTime();
        let chatTime = Number(store.onlineConfig.chatTime)||30;
        let hasSendpresetText = Storage.getItem('hasSendpresetText');
        if(store.hasPushPresetText){return}
        Storage.setItem('presetTextTime',currentTime,sendPeriod);
        let presetTextTime = currentTime;
        clearInterval(store.timer);

        /*如果没有发过就直接发送*/
        if(!hasSendpresetText){
            store.timer = setInterval(()=>{
                if(new Date().getTime() - presetTextTime>chatTime*1000){
                    clearInterval(store.timer);
                    let hasSendMsg = Storage.getItem('hasSendMsg');
                    if(hasSendMsg){
                        Storage.removeItem('presetTextTime')
                        return
                    }
                    Storage.setItem('hasSendpresetText',true,sendPeriod);       //10分钟发一次
                    let time = new Date().getTime()+(store.serverTime);
                    Storage.setItem('sendMsgTime',time,50);
                    store.hasPushPresetText  =true
                    store.msgList.push({
                        time:time,
                        text:store.onlineConfig.chatTxt,
                        flow: "in",
                        msg_status:'success',
                        type: "customtext"
                    });
                    if(!store.showChatModel){
                        store.noSeeList.push({
                            time:time,
                            text:store.onlineConfig.chatTxt,
                            flow: "in",
                            msg_status:'success',
                            type: "customtext"
                        })
                    }

                }
            },1000)
        }
        clearInterval(store.timer2)
        store.timer2 = setInterval(()=>{
            let hasSendpresetText1 =  Storage.getItem('hasSendpresetText');
            let windowOnfocus = getHzLocVal('windowOnfocus');
            if(hasSendpresetText1){
                Storage.setItem('hasSendpresetText',true,sendPeriod);       //10分钟发一次
            }

            let hasSendMsg = Storage.getItem('hasSendMsg');
            if(hasSendMsg){
                Storage.setItem('hasSendMsg',true,sendPeriod);       //10分钟发一次
            }

            if(windowOnfocus&&windowOnfocus=='true'){
                MsgTitleWarnFn.hideTitle();
            }
        },1000*2)
    },





    pushPresetTextFn(){
        if(store.preFormTag) return;
        if(store.isLeaveMessage) return;
        if(!store.onlineConfig.hasOwnProperty('chatTxt')) return;
        if(store.onlineConfig.chatTxt=='') return;
        let hasSendMsg = Storage.getItem('hasSendMsg');
        if(hasSendMsg){
            Storage.removeItem('presetTextTime')
            return
        }
        if(!store.hasPushPresetText&& !store.timer){
            // let presetTextTime = getHzLocVal('presetTextTime');
            let sendMsgTime = Storage.getItem('sendMsgTime');
            if(!sendMsgTime||store.hasPushPresetText){return}
            store.msgList.push({
                time:Number(sendMsgTime),
                text:store.onlineConfig.chatTxt,
                flow: "in",
                msg_status:'success',
                type: "customtext"
            });
            store.hasPushPresetText = true;
        }
    },

    sendPresetTxt(){
        clearInterval(store.timer);
        store.timer = null;
        let hasSendpresetText = Storage.getItem('hasSendpresetText');
        if(!hasSendpresetText){
            mutations.sendPresetTextFn();
        }else {
            mutations.pushPresetTextFn();
        }
    },

    setForm(data) {
        store.onLineForm = [].concat(data.online);
        store.offLineForm = [].concat(data.offline);
    },

    setServerReadLastTime(val) {
        store.serverReadLastTime = val;
    },
    setUnReadCount(val) {
        store.unReadCount = val;
    },
    setFirstMsgList(val) {
        // store.msgList.push(JSON.parse(val));
        if (!store.Nim) {
            let data = JSON.parse(val);
            data.flow = 'in'
            mutations.onmsg(data);
        }

    },


    initForm(){
        if(store.hasPushForm){return}
        if (store.isLeaveMessage) {
            store.hasPushForm = true;
            store.msgList.push({
                time: new Date().getTime()+store.serverTime,
                flow: "offline_form",
                type: "offlineForm",
            })

        } else {
            if(store.preFormTag == true&&!store.hasSubOnlineForm){
                store.hasPushForm = true
                store.msgList.push({
                    time: new Date().getTime()+store.serverTime,
                    flow: "online_form",
                    type: "onlineForm",
                })
            }
        }
        console.info("store_msgList",store.msgList);
    },

    setBlack(val) {
        store.currIsBlack = val;
    },
    setMsgList(val) {
        mutations.onmsg(val)
    },
    setFailMsgClientId(id) {
        store.failMsgClientId.push(id);
    },

    SubOnlineForm(){
        store.socket.SubOnlineForm();
    },

    /*
    * 消息重发
    * */
    resendMsg(msgObj) {
        let msg = JSON.parse(JSON.stringify(msgObj));
        msg.msg_status = 'sending';
        msg.resend = true;
        if (msg.type == 'custom') {
            msg.content = JSON.stringify(msg.content)
        }
        mutations.updateMsgStatus(msg)
        store.Nim.resendMsg({
            msg: msg,
            needMsgReceipt: true,
            done: function (error, data) {
                if (error) {
                    console.info("重发失败", error);
                    data.msg_status = 'fail'
                } else {
                    console.info("发送返回的数据", data);
                    data.msg_status = 'success'
                }
                mutations.updateMsgStatus(data)
            },
        })
    },

    /*
    * 更新消息状态
    * */
    updateMsgStatus(data) {    //更新失败的消息
        store.msgList.forEach((item, index) => {
            if (data.idClient&&item.idClient == data.idClient) {
                item.msg_status = data.msg_status;
                item.status = data.status;
                item.time = data.time;
                // if(item.msg_status=='success'&&item.resend){
                //     store.failMsgClientId.splice(store.failMsgClientId.indexOf(data.idClient),1)
                //     store.networkWarning = '';
                //     store.msgList.splice(index,1);
                //     store.msgList.push(item);
                // }
            }
        })
    },

    setWindowOnfocus(val){
        console.info("windowOnfocus",val)
        MsgTitleWarnFn.hideTitle();
        setHzLocalVal('windowOnfocus',val,1000);       //10分钟发一次
        store.windowOnfocus = val;
        if(val){
            mutations.sendMsgReceipt();
        }

    },


    onmsg: function (data) {
        if(!Storage.getItem('hasSendpresetText')){
            Storage.setItem('hasSendMsg',true,sendPeriod);       //10分钟发一次
            Storage.removeItem('presetTextTime')
            clearInterval(store.timer);
        }
        store.historyMsgList.push(data);
        if (data.type == 'text') {
            if (/\[[^\]]+\]/.test(data.text)) {
                let emojiItems = data.text.match(/\[[^\]]+\]/g);
                emojiItems.forEach(text => {
                    let emojiCnt = emojiList;
                    let indexof = emojiCnt.indexOf(text)
                    if (indexof >= 0) {
                        data.text = data.text.replace(text, `<img  src="${faceUrl}${indexof}.png">`)
                    }
                })
            }
            // 发送的消息添加ai消息输入的状态
        }
        if (data.type == 'custom') {
            data.content = JSON.parse(data.content);
            if(data.content.type=='onlineform'){
                store.hasSubOnlineForm = true;

            }
        }
        data.toBottom = true;
        store.msgList.push(data);
        console.info('msgLsit',store.msgList);
        if (!store.showChatModel) {
            store.noSeeList.push(data);
        }

        let windowOnfocus = getHzLocVal('windowOnfocus');
        // console.info("windowOnfocus",windowOnfocus);
        // console.info("store.showChatModel",store.showChatModel);
        // console.info('dataFlow',data.flow)
        if(data.flow=='in'&&windowOnfocus=='false'){
            MsgTitleWarnFn.showTitle();
        }else{
            console.info("消息来了")
            mutations.sendMsgReceipt();

        }

        if(data.flow==='out' && store.serviceMsgNum<2){   //自己发送的消息
            this.autoReply(data)
            if(store.conversionConfigId == 3){
                creatConversionDiv();
            }
            console.info("msg out",data)
        }
        if(data.flow==='in'){   //来消息了
            if(data.fromClientType==="Server"){
                  store.serviceMsgNum++;

            }else{
                store.serviceMsgNum=3;
            }
            console.info("msg in",data)
            // 隐藏ai消息输入的状态
            store.isInput=false;
        }


        //
        // if (!store.Nim || store.NimStatus == false) {
        //     mutations.connectNim();
        // }

        // store.isInput=false;
        // store.toBottom =true;
    },

    //用户发了消息，下面的自动回复时间默认3秒，3秒内客服没有回复，发送文本1。
    // 用户接着又发了消息，3秒内客服还是没回复，发送文本2
    async autoReply() {
        // 自动回复的时间
        const autoReplyTime = store.onlineConfig.autoReplayTime||3;
        // 是否自动回复
        const autoReply = store.onlineConfig.autoReply;
        if(autoReply){
             await wait(autoReplyTime)
            const res = await mutations.sendAutoReplyMsg()
            if(res.code==='001'){
                if(res.data.isTodaySendOver&&res.data.isTodaySendOver===true){
                    store.serviceMsgNum=3;
                }
            }
        }

        // console.info("自动回复",res)
    },

     async sendAutoReplyMsg() {
        if(store.serviceMsgNum>=2){
            return
        }
         if(store.msgList.length>0&&store.msgList[store.msgList.length-1].flow==='in'&&store.msgList[store.msgList.length-1].fromClientType!=='Server'){
            return
        }
        const autoReplyContent1 = store.multyLang[store.autoReplyContent1][store.currentTranslateCode];
        const autoReplyContent2 = store.multyLang[store.autoReplyContent2][store.currentTranslateCode];
        try {
            let response = await new Promise((resolve, reject) => {
                hzAjax({
                    type: 'post',
                    url: baseChatUrl + '/yunxin/sendMessage',
                    contentType: 'application/json',
                    data: JSON.stringify({
                        serviceMsgNum: store.serviceMsgNum,
                        autoReplyContent1: autoReplyContent1,
                        autoReplyContent2: autoReplyContent2,
                        autoReplayTime: store.onlineConfig.autoReplayTime||3,
                        visitorId: store.visitorId,
                        from: store.custemInfo.accid,
                        ope: 0,
                        to: store.imAccid,
                        type: 0,
                        body: JSON.stringify({ msg: store.serviceMsgNum===0 ? autoReplyContent1 : autoReplyContent2 }),
                        ext: mutations.getCustemData(1)
                    }),
                    success: (data) => {
                        resolve(data)
                    },
                    error: (err) => reject(err)
                });
            });
            return response
            console.info("自动回复成功", response);
        } catch (error) {
            console.error("自动回复失败", error);
        }
    },


    /*
    * 访客进入页面--初始化客服信息
    * */
    setInitData(res) {
        store.custemInfo.hasChange = false;
        store.custemInfo = Object.assign({}, res.customerServerDto);
        console.log("访客进入页面--初始化客服信息", store.custemInfo);
        if (store.custemInfo.hasOwnProperty('serverId')) {
            window.utilConfig.serverId = store.custemInfo.serverId
        }
        store.imAccid = res.imAccid;
        store.imToken = res.imToken;
        store.visitorId = res.visitorId;
        store.visitorCode = res.visitorCode;
        store.companyId = res.companyId;
        store.isLeaveMessage = res.isLeaveMessage;
    },

    sendText(text) {
        let _this = this;
        if (!store.Nim || store.NimStatus == false) {
            mutations.connectNim();
            sendTextFn(true)
        } else {
            sendTextFn()
        }
        console.info('当前的客服id============' + store.custemInfo.accid);

         function sendTextFn(flag) {
            let msg = store.Nim.sendText({
                scene: 'p2p',
                to: store.custemInfo.accid,
                text: text,
                custom: mutations.getCustemData(),
                done: async function (error, data) {
                    console.log("发送消息", error, data);
                    let resendMsg = Object.assign({},data);
                    if (error) {
                        // console.info("重发失败", error);
                        if (!flag) {
                            data.msg_status = 'fail'
                        } else {
                            data.msg_status = 'sending'
                            store.noSendMsg.push(resendMsg);
                        }
                    } else {
                        // console.info("发送返回的数据", data);
                        data.msg_status = 'success'
                         // visitorId+companyId+serverId
                        const signString = `${store.visitorId}-${utilConfig.enterpriseId}-${store.custemInfo.serverId}`;
                        console.log("signString", signString);
                        let sign = aesEncrypt(signString);
                        console.log("sign", sign);
                        // 访客发送消息
                       let visitorSendsMessage =  await new Promise((resolve, reject) => {
                            hzAjax({
                                type: 'post',
                                url: baseChatUrl + '/im/message/ai/visitor/send',
                                contentType: 'application/json',
                                data: JSON.stringify({
                                    message: data.text,
                                    serverAccid: store.custemInfo.accid,
                                    visitorAccid: store.imAccid,
                                    visitorId: store.visitorId,
                                    visitorCode: utilConfig.visitorid,
                                    companyId: utilConfig.enterpriseId,
                                    serverId: store.custemInfo.serverId,
                                    sign: sign
                                }),
                                success: (data) => {
                                    resolve(data)
                                },
                                error: (err) => reject(err)
                            });
                        });
                        console.info("发送消息成功", visitorSendsMessage);
                        if (visitorSendsMessage.code == '001') {
                            console.log('data', visitorSendsMessage.data);
                            if (visitorSendsMessage.data == true) {
                                store.isInput=true;
                            }
                        }
                    }
                    mutations.updateMsgStatus(data)
                    // console.info("发送失败的回调",error)
                    // if(data.status=='success'){
                    //     mutations.onmsg(data)
                    // }else{
                    //     setTimeout(function () {
                    //         mutations.sendText(text)
                    //     })
                    //
                    // }

                },
            })
            console.info('要发送的消息', msg);
            msg.msg_status = 'sending';
            msg.time = new Date().getTime()+(store.differenceTime);
            mutations.onmsg(msg)
        }

    },

    sendCustomMsg(obj) {
        let _this = this;
        let content = {
            type: obj.type,
            data: obj.txt,
        };
        if (!store.Nim || store.NimStatus == false) {
            mutations.connectNim();
            sendCustomMsgFn(true);
        } else {
            sendCustomMsgFn();
        }

        function sendCustomMsgFn(flag) {
            let msg = store.Nim.sendCustomMsg({
                scene: 'p2p',
                custom: mutations.getCustemData(),
                to: store.custemInfo.accid,
                content: JSON.stringify(content),
                done: function (error, data) {
                    if (error) {
                        console.info("重发失败", error);
                        if (!flag) {
                            data.msg_status = 'fail'
                        } else {
                            data.msg_status = 'sending'
                            store.noSendMsg.push(msg);
                        }
                    } else {
                        console.info("发送返回的数据", data);
                        data.msg_status = 'success'
                    }
                    mutations.updateMsgStatus(data)
                    // if(data.status=='success'){
                    //     mutations.onmsg(data)
                    // }else{
                    //     mutations.sendText(text)
                    // }
                }
            });

            msg.msg_status = 'sending';
            msg.time = new Date().getTime()+(store.differenceTime);
            mutations.onmsg(msg)
        }
    },
    sendFile(file) {
        let _this = this;
        let type = 'file'

        if (/\.(png|jpg|bmp|jpeg|gif)$/i.test(file.files[0].name)) {
            type = 'image'
        }
        if (!store.Nim || store.NimStatus == false) {
            mutations.connectNim();
            sendFileFn(true);
        } else {
            sendFileFn()
        }

        function sendFileFn(flag) {
            store.Nim.sendFile({
                scene: 'p2p',
                to: store.custemInfo.accid,
                custom: mutations.getCustemData(),
                type: type,
                commonUpload:true,
                fileInput: file,
                uploadprogress: function (obj) {
                    console.log('文件总大小: ' + obj.total + 'bytes');
                    console.log('已经上传的大小: ' + obj.loaded + 'bytes');
                    console.log('上传进度: ' + obj.percentage);
                    console.log('上传进度文本: ' + obj.percentageText);
                    store.percentage = obj.percentage;
                },
                uploaddone: function (error, file) {
                    store.showProgerss = false;
                    store.percentage = 0;
                    console.log('上传' + (!error ? '成功' : '失败'), error, file);
                },
                beforesend: function (msg) {
                    console.log('正在发送p2p image消息, id=' + msg.idClient);
                    msg.msg_status = 'sending';
                    msg.time = new Date().getTime()+(store.differenceTime);
                    mutations.onmsg(msg)
                },
                beginupload(opt) {
                    store.percentage = 0;
                    store.showProgerss = true;
                },
                done: function (error, data) {
                    if (error) {
                        if (error.code == 'File_Too_Large') {
                            Message.warning("文件太大，超过100M的限制")
                            return
                        }
                        if (!flag) {
                            data.msg_status = 'fail'
                        } else {
                            data.msg_status = 'sending'
                            store.noSendMsg.push(data);
                        }
                    } else {
                        console.info("发送返回的数据", data);
                        data.msg_status = 'success'
                    }
                    mutations.updateMsgStatus(data)
                }
            })
        }

    },


    sendScreenshotFile(file) {
        if (!store.Nim || store.NimStatus == false) {
            mutations.connectNim();
            sendFileFn(true);
        } else {
            sendFileFn()
        }

        function sendFileFn(flag) {
            store.Nim.sendFile({
                scene: 'p2p',
                to: store.custemInfo.accid,
                custom: mutations.getCustemData(),
                type: 'image',
                commonUpload:true,
                dataURL: file,
                uploadprogress: function (obj) {
                    console.log('文件总大小: ' + obj.total + 'bytes');
                    console.log('已经上传的大小: ' + obj.loaded + 'bytes');
                    console.log('上传进度: ' + obj.percentage);
                    console.log('上传进度文本: ' + obj.percentageText);
                    store.percentage = obj.percentage;
                },
                uploaddone: function (error, file) {
                    store.showProgerss = false;
                    store.percentage = 0;
                    console.log('上传' + (!error ? '成功' : '失败'), error, file);
                },
                beforesend: function (msg) {
                    console.log('正在发送p2p image消息, id=' + msg.idClient);
                    msg.msg_status = 'sending';
                    msg.time = new Date().getTime()+(store.differenceTime);
                    mutations.onmsg(msg)
                },
                beginupload(opt) {
                    store.percentage = 0;
                    store.showProgerss = true;
                },
                done: function (error, data) {
                    if (error) {
                        if (error.code == 'File_Too_Large') {
                            Message.warning("文件太大，超过100M的限制")
                            return
                        }
                        if (!flag) {
                            data.msg_status = 'fail'
                        } else {
                            data.msg_status = 'sending'
                            store.noSendMsg.push(data);
                        }
                    } else {
                        console.info("发送返回的数据", data);
                        data.msg_status = 'success'
                    }
                    mutations.updateMsgStatus(data)
                }
            })
        }

    },

    sendSysCustemMsg(data) {       //自定义系统消息，实现正在输入中
        var content = {
            type: 'type',
            value: data,
            visitorId: store.visitorId
        };
        content = JSON.stringify(content);
        if (store.Nim) {
            store.Nim.sendCustomSysMsg({
                scene: 'p2p',
                to: store.custemInfo.accid,
                content: content,
                done: function (msg, error) {
                    console.log('发送=========自定义系统通知' + (!error ? '成功' : '失败'));
                }
            });
        }
    },

    /*
    * 发送消息回执----已读未读
    * */
    sendMsgReceipt(lastTime) {
        if(store.msgList.length>0){
            let time = store.msgList[store.msgList.length - 1].time;
            store.socket.vLastTimes(time)
        }
    },

    /*
    * 处理历史消息
    * */
    dealHistoryMsg(res) {
        // mutations.pushPresetTextFn();
        if(res.length==0){
            store.hasHistoryMsg = false;
            return
        }

        let historyMsg = [];
        res.forEach((item, index) => {
            let historyMsgItem = {
                flow: item.direction == 0 ? 'out' : 'in',
                time: item.msgTimestamp,
                file: {},

            }
            switch (item.msgType) {
                case 'FILE':
                    let fileAttach = JSON.parse(item.attach)
                    historyMsgItem.type = 'file';
                    historyMsgItem.file.size = fileAttach.size;
                    historyMsgItem.file.url = fileAttach.url;
                    historyMsgItem.file.name = fileAttach.name;
                    historyMsgItem.file.ext = fileAttach.ext;
                    break
                case  'PICTURE':
                    let imageAttach = JSON.parse(item.attach)
                    historyMsgItem.type = 'image'
                    historyMsgItem.file.url = imageAttach.url;
                    historyMsgItem.file.name = imageAttach.name;
                    historyMsgItem.ext = imageAttach.ext;
                    break
                case  'CUSTOM':
                    let cusetomAttach = JSON.parse(item.attach)
                    historyMsgItem.type = 'custom';
                    historyMsgItem.text = cusetomAttach.data;
                    historyMsgItem.content = cusetomAttach;
                    break
                case 'TEXT':
                    historyMsgItem.type = 'text'
                    historyMsgItem.text = item.body;
                    if (/\[[^\]]+\]/.test(item.body)) {
                        let emojiItems = item.body.match(/\[[^\]]+\]/g)
                        let emojiCnt = emojiList;
                        emojiItems.forEach(text => {
                            let indexof = emojiCnt.indexOf(text)
                            if (indexof >= 0) {
                                historyMsgItem.text = historyMsgItem.text.replace(text, `<img  src="${faceUrl}${indexof}.png">`);
                            }
                        })
                    }
                break
            }
            if (store.msgList.length <= 0) {
                historyMsgItem.toBottom = true;
            }
            historyMsg.unshift(historyMsgItem);
            store.historyMsgList.push(historyMsgItem);

        })
        if (res.length < historyMsgNum) {
            store.hasHistoryMsg = false
        }
        store.loadHistory = false;
        store.msgList = historyMsg.concat(store.msgList);
        console.info(store.msgList)
        // mutations.sortHistoryMsg();
        // if(!store.preFormTag&&res.length<historyMsgNum){
        //     mutations.sendPresetText(2);
        // }

    },


    //连接nim
    connectNim(callback) {
        if (!store.NimStatus) {
            new Nim(callback);
        }

    },

    /*
    * 发送的自定义数据
    * */
    getCustemData(direction) {
        return JSON.stringify({
            direction: direction?direction:'0',  //消息发送的方向 0 访客-客服 1 客服-访客
            visitorId: store.visitorId,
            visitorCode: utilConfig.visitorid,
            companyId: utilConfig.enterpriseId,
            serverId: store.custemInfo.serverId,
        })
    },


    /*
    * 客服转移，客服状态变化以后收到的数据
    * 访客首次进入客服是在线状态，中间不能切换状态
    * 访客首次进入客服是离线状态，客服上线以后可以改变状态
    *
    * */
    setServerData(res) {
        console.info("转移之后分配的客服", res);
        store.custemInfo.accid = res.serverAccid;
        store.custemInfo.serverId = res.serverId;
        store.custemInfo.onlineStatus = res.onlineStatus ? 1 : 0;
        store.isLeaveMessage = res.isLeaveMessage;
        store.custemInfo.hasChange = true;
        store.custemInfo = Object.assign({}, store.custemInfo);
        console.info('合并以后的客服', store.custemInfo)
        if (store.custemInfo.hasOwnProperty('serverId')) {
            window.utilConfig.serverId = store.custemInfo.serverId
        }
        mutations.initForm();


        if(!store.preFormTag){
            mutations.sendPresetTxt();
        }
        // if(!store.hasHistoryMsg&&!store.preFormTag&&store.msgList.length>1){
        //     mutations.sendPresetText(2);
        // }

        // if(!store.isLeaveMessage){
        //     mutations.sendPresetText(1)
        // }
    },

    /*
    * 多语言数据包
    * */
    setMultyLang(res) {
        store.multyLang = Object.assign({}, res);
    },

    /*
    * 当前翻译的code
    * */
    setCurrentTranslateCode(val) {
        store.currentTranslateCode = val;
    },
    undoMsg(data){
        console.info(data);
        store.msgList.forEach((item,index)=>{
            if(item.idClient==data.deletedIdClient){
                store.msgList.splice(index,1);
            }
        })

        store.noSeeList.forEach((item,index)=>{
            if(item.idClient==data.deletedIdClient){
                store.noSeeList.splice(index,1);
            }
        })
    },

    //  saveLog: function (type, desc) {
    //     var url = baseUrl_8 + '/visit/log'
    //     var params = {
    //         type: type,
    //         desc: desc,
    //         time: (new Date).format("yyyy-MM-dd hh:mm:ss:S"),
    //         visitorid: window.utilConfig ? utilConfig.visitorid : '',
    //         href: window.location.href,
    //         isMobile: false,
    //         browser: window.BrowserName,
    //         language: (navigator.browserLanguage || navigator.language).toLowerCase(),
    //
    //     }
    //     hzAjax({
    //         type: "POST",
    //         url: url,
    //         contentType: "application/json",
    //         data: JSON.stringify(params),
    //         success: function () {
    //         }
    //     })
    // },

}
